<template>
  <v-dialog v-model="dialog" max-width="1100px" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title class="text-uppercase">CHI TIẾT KỲ ĐÓNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="close">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0 mt-6">
          <v-row>
            <v-col cols="12">
              <v-card elevation="0" outlined>
                <v-data-table
                  :headers="computedHeaders"
                  :items="items"
                  hide-default-footer
                  class="elevation-0"
                  disable-sort
                  dense
                >
                  <template v-slot:item="{ item }" v-if="isHybrid">
                    <tr>
                      <td rowspan="2" class="text-center">{{ item.metadata.month }}</td>
                      <td class="text-center">{{ get(item, 'metadata.totalLessons') }}</td>
                      <td>
                        {{ formatPaymentType(item.metadata.paymentType) }}
                      </td>
                      <td>Offline</td>
                      <td class="font-weight-medium text-right">
                        {{ Number(item.metadata.amount).toLocaleString() }} VNĐ
                        <span class="grey--text text--darken-1">{{ formatPriceType(item.metadata.priceType) }}</span>
                      </td>
                      <td>{{ formatPeriodicType(item.metadata.periodic) }}</td>
                      <td class="font-weight-bold primary--text text-right">{{ Number(item.price).toLocaleString() }}
                        VNĐ
                      </td>
                      <td>
                        <currency-input
                          v-if="item.period.status !== 'finished' && isEditMode === true"
                          class="currency-input py-4 px-2"
                          v-model="item.actualPrice"
                          prefix="VNĐ"
                          dense
                          hide-details
                          @change="() => handleChangePrice(item)"
                        />
                        <div
                          v-else
                          class="font-weight-bold red--text text-right my-6">
                          {{ item.actualPrice ? Number(item.actualPrice).toLocaleString() + ' VNĐ' : '&nbsp;' }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-center">{{ item.metadata.totalLessons }}</td>
                      <td>
                        {{ formatPaymentType(item.metadata.paymentType) }}
                      </td>
                      <td>Online</td>
                      <td class="font-weight-medium text-right">
                        {{ Number(item.metadata.onlineAmount).toLocaleString() }} VNĐ
                        <span class="grey--text text--darken-1">{{ formatPriceType(item.metadata.priceType) }}</span>
                      </td>
                      <td>{{ formatPeriodicType(item.metadata.periodic) }}</td>
                      <td class="font-weight-bold primary--text text-right">
                        {{ Number(item.onlinePrice || 0).toLocaleString() }} VNĐ
                      </td>
                      <td>
                        <currency-input
                          v-if="item.period.status !== 'finished' && isEditMode === true"
                          class="currency-input py-4 px-2"
                          :disabled="item.period.status === 'finished'"
                          v-model="item.onlineActualPrice"
                          prefix="VNĐ"
                          dense
                          hide-details
                          @change="() => handleChangePrice(item)"
                        />
                        <div
                          v-else
                          class="font-weight-bold red--text text-right my-6"
                        >
                          {{ item.onlineActualPrice ? Number(item.onlineActualPrice).toLocaleString() + ' VNĐ' : '&nbsp;'
                          }}
                        </div>
                      </td>
                    </tr>
                  </template>

                  <template #[`item.month`]="{ item }" v-if="!isHybrid">
                    {{ item.metadata.month }}
                  </template>
                  <template #[`item.amount`]="{ item }" v-if="!isHybrid">
                    <div class="font-weight-medium">
                      {{ Number(item.metadata.amount).toLocaleString() }} VNĐ
                      <span class="grey--text text--darken-1">{{ formatPriceType(item.metadata.priceType) }}</span>
                    </div>
                  </template>
                  <template #[`item.paymentType`]="{ item }" v-if="!isHybrid">
                    {{ formatPaymentType(item.metadata.paymentType) }}
                  </template>
                  <template #[`item.totalLessons`]="{ item }" v-if="!isHybrid">
                    <div class="text-center">{{ item.metadata.totalLessons }}</div>
                  </template>
                  <template #[`item.price`]="{ item }">
                    <div class="font-weight-bold primary--text">{{ Number(item.price).toLocaleString() }} VNĐ</div>
                  </template>
                  <template #[`item.periodic`]="{ item }" v-if="!isHybrid">
                    <div class="">{{ formatPeriodicType(item.metadata.periodic) }}</div>
                  </template>
                  <template #[`item.actualPrice`]="{ item }" v-if="!isHybrid">
                    <currency-input
                      v-if="item.period.status !== 'finished' && isEditMode === true"
                      class="currency-input py-4 px-2"
                      v-model="item.actualPrice"
                      prefix="VNĐ"
                      dense
                      hide-details
                      @change="() => handleChangePrice(item)"
                    />
                    <div
                      v-else
                      class="font-weight-bold red--text text-right my-6">
                      {{ item.actualPrice ? Number(item.actualPrice).toLocaleString() + ' VNĐ' : '&nbsp;' }}
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6" v-if="isEditMode === false">
        <v-spacer></v-spacer>
        <v-btn @click="isEditMode = true" outlined color="#0D47A1">Sửa chi tiết kỳ đóng</v-btn>
      </v-card-actions>
      <v-card-actions class="d-flex justify-space-between pa-6" v-else>
        <v-btn class="text-none text-uppercase" outlined @click="close">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" :loading="loading" @click="saveChanges">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import get from 'lodash-es/get'
import padStart from 'lodash-es/padStart'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'
import CurrencyInput from '@/components/basic/input/CurrencyInput.vue'

export default {
  name: 'DialogDetailPeriod',

  components: {
    CurrencyInput,
    BaseBodyDialog,
  },

  data() {
    return {
      dialog: false,
      isEditMode: false,
      loading: false,
      headers: [
        { text: 'Tháng', value: 'month', align: 'left' },
        { text: 'Số buổi dự kiến', value: 'totalLessons', align: 'center' },
        { text: 'Hình thức thu', value: 'paymentType', align: 'left' },
        { text: 'Buổi học', value: 'classMode', align: 'left' },
        { text: 'Mức phí', value: 'amount', align: 'right' },
        { text: 'Định kỳ', value: 'periodic', align: 'left' },
        { text: 'Số tiền thu dự kiến', value: 'price', align: 'right' },
        { text: 'Điều chỉnh thực tế', value: 'actualPrice', align: 'right', width: '20%' },
      ],
      modifiedPrices: {},
      modifiedOnlinePrices: {},
      isHybrid: false,
    }
  },

  computed: {
    ...mapState('tuitionFeeGroupHeadFee', ['groupHeadFee']),
    computedHeaders() {
      if (!this.isHybrid) {
        return this.headers.filter(header => header.value !== 'classMode')
      }
      return this.headers
    },
    items() {
      return get(this.groupHeadFee, 'prices', [])
    },
  },

  filters: {
    renderMonth(metadata = {}) {
      const month = get(metadata, 'month', 0)
      const year = get(metadata, 'year', 0)
      if (typeof month === 'number' && month) {
        const res = padStart(month, 2, '0')
        if (typeof year === 'number' && year) return res + ` (${year})`
        return res
      }
      return '-'
    },
  },

  methods: {
    get,
    ...mapActions('tuitonFeePrice', ['updateActualPrice']),
    ...mapActions('tuitionFeeGroupHeadFee', ['fetchOne', 'updatePrice']),
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    formatPriceType(type) {
      const types = {
        per_session: '/ buổi',
        monthly: '/ tháng',
        quarterly: '/ 3 tháng',
        '2month': '/ 2 tháng',
        course: '/ khóa',
      }
      return types[type] || type
    },
    formatPaymentType(type) {
      const types = {
        pre: 'Thu trước (đầu kỳ)',
        post_actual: 'Thu sau (cuối kỳ)',
        post_expected: 'Thu sau (theo dự kiến)',
        pre_one: 'Thu trước (1 đợt)',
        pre_many: 'Thu trước (nhiều đợt)',
      }
      return types[type] || type
    },
    formatPeriodicType(type) {
      const types = {
        1: 'Theo mỗi tháng',
        2: '2 tháng 1 lần',
        3: '3 tháng 1 lần',
      }
      return types[type] || type
    },
    openDialog(item, isHybrid = false) {
      this.dialog = true
      this.isHybrid = isHybrid
      const cloneItem = { ...item }
      const cloneMeta = { ...cloneItem.metadata }
      this.fetchOne(cloneMeta['apply'])
    },
    close() {
      this.dialog = false
      this.isEditMode = false
      this.modifiedPrices = {}
    },
    handleChangePrice(item) {
      this.modifiedPrices[item.id] = {
        actualPrice: item.actualPrice,
        onlineActualPrice: get(item, 'onlineActualPrice'),
      }
    },
    async saveChanges() {
      this.loading = true
      try {
        const promises = Object.entries(this.modifiedPrices).map(([id, { actualPrice, onlineActualPrice }]) => {
          return this.updateActualPrice({ id, actualPrice, onlineActualPrice })
        })
        await Promise.all(promises)
        this.$alert.success('Cập nhật giá thành công')
        this.close()
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra khi cập nhật giá')
        console.log(error)
      } finally {
        this.loading = false
        this.isEditMode = false
      }
    },
  },
}
</script>
